import script from "./block-data.vue?vue&type=script&setup=true&lang=ts"
export * from "./block-data.vue?vue&type=script&setup=true&lang=ts"

import "./block-data.vue?vue&type=style&index=0&id=026df8e5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026df8e5"]])

export default __exports__